<template>
  <span class="svg_icon" :class="[className, noRtlTransform ? 'no-rtl-transform' : '']">
    <inline-svg ref="svgRef" :src="require('../assets/svg' + path + '/' + icon)" />
  </span>
</template>

<script lang="ts">
import { defineComponent, nextTick, ref, onMounted } from 'vue';

export default defineComponent({
  props: {
    icon: {
      type: String,
    },
    path: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    noRtlTransform: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const svgRef = ref();

    const patchViewBox = () => {
      let svgEl = svgRef.value?.$el;

      if (!svgEl) return;

      // If $el is not an SVG element, try to find it inside
      if (svgEl.tagName?.toLowerCase() !== 'svg') {
        svgEl = svgEl.querySelector?.('svg');
      }

      if (!svgEl || svgEl.tagName?.toLowerCase() !== 'svg') return;

      if (!svgEl.hasAttribute('viewBox')) {
        let width = svgEl.getAttribute('width');
        let height = svgEl.getAttribute('height');

        if (!width || !height) {
          const style = getComputedStyle(svgEl);
          width = width || style.width.replace('px', '');
          height = height || style.height.replace('px', '');
        }

        svgEl.setAttribute('viewBox', `0 0 ${width || '24'} ${height || '24'}`);
      }
    };

    onMounted(async () => {
      await nextTick();
        setTimeout(() => {
          patchViewBox();
        }, (200));
    });

    return { svgRef };
  },
});
</script>

<style lang="scss">
.svg_icon {
  width: 25px;
  height: 25px;
  display: inline-block !important; 
  fill: var(--color-white);

  svg {
    height: 100%;
    width: 100%;
    display: block;
  }

  &.topAligned {
    svg {
      vertical-align: top;
    }
  }

  &.s-white {
    stroke: var(--color-white);
  }

  &.f-none {
    fill: var(--color-black);
  }
}
[dir="rtl"] {
  .svg_icon {
    &:not(.no-rtl-transform) {
      transform: scaleX(-1);
    }
  }
}
</style>
